import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from '../../../../api/';
import Modal from "./Modal.js";
import ParadigmaTable from "../../../../components/ParadigmaTable/";
import FormatFunctions from "../../../../functions/functions";

class Novedades extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Titulo",
                    id: "Titulo",
                    accessor: "Titulo",
                    show: true,
                    filterable: true,
                    width: 300,
                },
                {
                    Header: "Contenido",
                    id: "Contenido_HTML",
                    accessor: "Contenido_HTML",
                    filterable: true,
                    show: true,
                },
                {
                    Header: "Fecha",
                    id: "Fecha",
                    className: "text-center",
                    accessor: d => FormatFunctions.FormatDate(d.Fecha),
                    filterable: true,
                    width: 200,
                    show: true,
                },
                {
                    Header: "Visible",
                    id: "DeBaja",
                    className: "text-center",
                    accessor: d => (d.DeBaja ? "SI" : "NO"),
                    filterable: true,
                    width: 100,
                    show: true,
                },
            ]
        };
    }

    static propTypes = {
        additionalFields: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            onGet: PropTypes.string.isRequired, // (data: data que llega del servidor) => objeto: { key: value } lo que retorna se setea en el estado
            onPost : PropTypes.string.isRequired, // (data: data del estado que se envia al servidor) => objeto: { key: value } lo que se envia al servidor
            Input: PropTypes.func.isRequired, // (state, setThis, disabled, error) => <Input />
        })),
    }

    render() {
        const { data, pages, loading } = this.state;
        const { additionalFields } = this.props;
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                    {
                       create: true,
                       permission: 'ecommerce_config_novedades_new',
                       component: (props) => <Modal {...props} action="CREATE" additionalFields={additionalFields} />,
                    },
                    {
                       edit: true,
                       permission: 'ecommerce_config_novedades_edit',
                       component: (props) => <Modal {...props} action="EDIT" additionalFields={additionalFields} />,
                    },
                    {
                       detail: true,
                       permission: 'ecommerce_config_novedades_detail',
                       component: (props) => <Modal {...props} action="DETAIL" additionalFields={additionalFields} />,
                    },
                    {
                       delete: true,
                       permission: 'ecommerce_config_novedades_delete',
                       component: (props) => <Modal {...props} action="DELETE" additionalFields={additionalFields} />,
                    },
                ]}
                apiUrl={api.gestion.sitio.novedades}
                columns={this.state.columns}
                title={"Novedades"}
            />
        );
    }
}

export default Novedades;



// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Novedades/Novedades.js